import { Component } from '@angular/core';
import {RouterLink} from '@angular/router';

@Component({
  selector: 'bor-app-footer',
  imports: [
    RouterLink
  ],
  templateUrl: './app-footer.component.html',
  styleUrl: './app-footer.component.scss',
})
export class AppFooterComponent {}
